import { faCamera, faCameraAlt, faChevronRight, faDice } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import EphemeList from '../../Component/EphemeList';
import Tabs from '../../Component/Tabs/Tabs';
import { PLATFORM } from '../../Hook/platform';
import Content from '../Content';
import Footer from '../Footer';
import Header from '../Header';
import Main from '../Main';
import MenuMobile from '../MenuMobile';

function Challenge() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <Content>
        <Main>
          <h2 className='text-center text-2xl [&>*]:text-primary'><FormattedMessage id="challenge__title" /></h2>
          <div className=' max-w-5xl w-full m-auto my-0 flex flex-col gap-8'>
            <div className='grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-6 bg-cards px-2 py-8'>
              {PLATFORM.challenges.map((e, i) => {
                const challengeTrophy = PLATFORM.trophies.find((t:any) => t.challenge == e.id);
                return <div onClick={() => navigate("/challenge/" + e.id)} key={i} 
                className="cursor-pointer bg-chatbg w-full border border-challenge hover:border-primary active:border-primary rounded-xl flex gap-6 p-4 items-center">
                  <div className='bg-cards w-10 h-10 rounded-full flex justify-center items-center'>
                    <img className='max-w-8 max-h-8' src={`${(window as any).__webpack_public_path__}trophies-icon/trophie_${challengeTrophy?.id}.png`} />
                  </div>
                  <div className='flex flex-col gap-2 flex-1'>
                    <div className='text-primary'><FormattedMessage id={"challenge__hashtag__" + e.id} /></div>
                    <div>
                      <div className='flex gap-2 items-center text-base leading-[0]'>
                        <FontAwesomeIcon className='text-base' icon={faCamera} />
                        <div>{e.nb_ephemes}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <FontAwesomeIcon icon={faChevronRight}  className='text-primary'/>
                  </div>
                </div>
              })}
            </div>
            <Tabs
              tabs={[
                <FormattedMessage id="snapstory__most_newest" />,
                <FormattedMessage id="snapstory__most_liked" />
              ]}
            >
              <EphemeList additionalInputs={{
                sort: 'date',
                type: "challenge"
              }} />
              <EphemeList additionalInputs={{
                sort: 'popularity',
                type: "challenge"
              }} />
            </Tabs>
          </div>
        </Main>
      </Content>
      <Footer />
      <MenuMobile />
    </>
  )
}

export default Challenge